module.exports = __webpack_public_path__ + "static/media/lbcj2.dfb70bf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/lbcj2.png
// module id = 558
// module chunks = 0